import React, { Component } from "react";
import cx from "classnames";
import style from "./Footer.module.scss";
import SocialLinks from "../../elements/SocialLinks/SocialLinks";
import { Link } from "gatsby";

export default class Footer extends Component {

  componentDidMount() {
    const script = document.createElement("script");
    script.id = "Cookiebot"
    script.src = "https://consent.cookiebot.com/uc.js";
    script.async = true;
    script.setAttribute("data-cbid", "1606728e-16d6-4b6f-bbf2-8e8b2ef8de81")
    document.body.appendChild(script);
  }

  render() {
    let date = new Date();
    return <footer className={style.footer}>
      <div className='container'>
        <div className={cx("row")}>
          <div className={style.main_row}>
            <div className={style.col1}>
              <div className={style.logo} />

              <div className={style.contact_info}>
                P.IVA: 02668420025<br></br>
                REA: BI 204055<br></br>
              </div>
              <div className={style.phone}>info@e-leads.it</div>
            </div>
            <div className={style.col2}>
              <div className={style.column_title}>Servizi</div>
              <div className={style.column_links}>
                <a href='/finanziario'>Finanziario</a>
                <a href='/assicurativo'>Assicurativo</a>
              </div>
            </div>
            <div className={style.col3}>
              <div className={style.column_title}>Su di noi</div>
              <div className={style.column_links}>
                <a href='/chi-siamo'>Chi siamo</a>
                <a href='/lavora-con-noi'>Lavora con noi</a>
              </div>
            </div>
            <div className={style.col4}>
              <div className={style.column_title}>Vieni a trovarci</div>
              <div className={cx("mb-4", style.column_links)}>
                <p>
                  Strada Statale Trossi 41
                <br />
                Verrone (BI)
              </p>
              </div>
              <SocialLinks />
            </div>
          </div>
        </div>
        <div className={cx("row", style.second_row)}>
          <div>© {date.getFullYear()} Tutti i diritti riservati</div>
          <div className={style.links}>
            <Link to='/Privacy-Policy-Sito-web'>Privacy Policy</Link> / <Link to='/Termini-e-condizioni-Sito-web'>Termini e condizioni</Link> / <Link to='/company-info'>Company info</Link>{/*  / <Link to='/credits'>Credits</Link> */}
          </div>
        </div>
      </div>{/* 
    <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="1606728e-16d6-4b6f-bbf2-8e8b2ef8de81" type="text/javascript" async></script> */}
    </footer>
  }
}

